module.exports = __webpack_public_path__ + "img/avatar3.3bab4728.png";